// composables/useBreadcrumbs.ts
import { computed } from "vue";
import { useRoute } from "vue-router";
import { type BreadcrumbLink } from "#ui/types";
import { useGetWorkspace } from "./workspaces/useGetWorkspace";
import { useGetProject } from "./projects/useGetProject";

export function useBreadcrumbs() {
  const route = useRoute();
  const { workspace } = useGetWorkspace();
  const { project } = useGetProject();
  // const { query } = useGetQuery()
  // const { alert } = useGetAlert()
  // const { notebook } = useGetNotebook()
  // const { dashboard } = useGetDashboard()

  const breadcrumbs = computed(() => {
    const pathSegments = route.path.split("/").filter((segment) => segment);
    const links: BreadcrumbLink[] = [];

    // Handle workspace (first segment)
    if (pathSegments[0]) {
      links.push({
        label: workspace.value?.name || "Loading...",
        to: `/${pathSegments[0]}`,
      });
    }

    if (pathSegments[1]) {
      if (pathSegments[1] === "settings") {
        links.push({
          label: "Settings",
          to: `/${pathSegments[0]}/${pathSegments[1]}`,
        });
      } else {
        // Handle project (second segment)
        links.push({
          label: project.value?.name || "Loading...",
          to: `/${pathSegments[0]}/${pathSegments[1]}`,
        });
      }
    }

    // Handle subsequent segments
    for (let i = 2; i < pathSegments.length; i++) {
      const segment = pathSegments[i];
      let currentPath = pathSegments.slice(0, i + 1).join("/");

      // If this is a known entity type
      if (["queries", "alerts", "notebooks", "dashboards"].includes(segment)) {
        links.push({
          label: segment.charAt(0).toUpperCase() + segment.slice(1),
          to: `/${currentPath}`,
        });

        // If there's a next segment (entity ID), get the entity name
        if (pathSegments[i + 1]) {
          const entityId = pathSegments[i + 1];
          let entityLabel = "Loading...";

          // Determine entity type and get appropriate name
          // switch (segment) {
          //   case 'queries':
          //     entityLabel = query.value?.name || 'Loading...'
          //     break
          //   case 'alerts':
          //     entityLabel = alert.value?.name || 'Loading...'
          //     break
          //   case 'notebooks':
          //     entityLabel = notebook.value?.name || 'Loading...'
          //     break
          //   case 'dashboards':
          //     entityLabel = dashboard.value?.name || 'Loading...'
          //     break
          // }

          links.push({
            label: entityLabel,
            ...(currentPath !== route.path ? { to: `/${currentPath}/${entityId}` } : {}),
          });

          // Skip the next segment (ID) since we've handled it
          i++;
        }
      } else if (segment === "new") {
        // If new slideover, don't do anything
      } else {
        // Handle other segments normally
        links.push({
          label: segment
            .split("-")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          ...(currentPath !== route.path ? { to: `/${currentPath}` } : {}),
        });
      }
    }

    return links;
  });

  return breadcrumbs;
}
